<template>
  <report-card
    title="Mail Work Orders"
    icon="fas fa-mail-bulk"
    is-date-range
    :loading="loading"
    @import="importEvent"
    @export="exportEvent"
  />
</template>

<script>
import { isExcel } from '@/utils/validationUtils';

export default {
  name: 'ReportDocumentsCard',
  components: {
    // 'al-dialog': () => import('@/components/core/Dialog'),
    // 'al-button': () => import('@/components/core/Button'),
    'report-card': () => import('./Item')
  },
  data: () => ({
    baseUrl: process.env.VUE_APP_BACKEND_DOMAIN,
    loading: false
  }),
  methods: {
    async importEvent(file) {
      try {
        if (!isExcel(file.name)) {
          this.$root.$emit('showToast', {
            message: 'Only excel files are allowed to be uploaded',
            options: { cssClass: 'is-danger', duration: 5000 }
          });
          return;
        }

        this.loading = true;

        const formData = new FormData();
        formData.append('file', file);

        // @todo REDO
        const url = `${this.baseUrl}workorder/mail_import`;
        const options = {
          headers: {
            Authorization: 'Bearer '.concat(this.$store.state.accessToken)
          },
          method: 'POST',
          body: formData
        };

        const response = await fetch(url, options);
        const { message } = JSON.parse(await response.text());

        if (!response.ok) {
          throw new Error(message);
        }

        this.$root.$emit('showToast', {
          message: message ?? 'File checked successfully',
          options: { cssClass: 'is-success', duration: 5000 }
        });
      } catch (error) {
        this.$root.$emit('showToast', {
          message: error?.response?.data?.message ?? error,
          options: { cssClass: 'is-danger', duration: 5000 }
        });
      } finally {
        this.loading = false;
      }
    },
    async exportEvent(range) {
      try {
        this.loading = true;

        const body = range.end && range.start ? JSON.stringify(range) : {};
        const url = `${this.baseUrl}workorder/mail_export`;
        const options = {
          headers: {
            Authorization: 'Bearer '.concat(this.$store.state.accessToken)
          },
          method: 'POST',
          responseType: 'blob',
          body
        };

        const response = await fetch(url, options);

        if (!response.ok) {
          const { message } = JSON.parse(await response.text());
          throw new Error(message);
        }

        const blob = await response.blob();
        const preparedUrl = window.URL.createObjectURL(blob);

        this.$root.$emit('showToast', {
          message: 'Downloaded Successfully',
          options: { cssClass: 'is-success', duration: 5000 }
        });

        window.open(preparedUrl, '_blank').focus();
      } catch (error) {
        this.$root.$emit('showToast', {
          message: error?.response?.data?.message ?? error,
          options: { cssClass: 'is-danger', duration: 5000 }
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
